<template>
  <v-container fluid>
    <section>
      <div v-html="page.tekst"/>
      <v-row class="mb-25">
        <v-col offset="2">
          <v-timeline dense align-top class="ml-8">
            <div v-for="year in publicationYears" :key="year" class="year">
              <div class="leaf">
                <span class="leaf-input subtitle-2">{{ year }}</span>
              </div>
              <div v-for="mention in mentions" :key="mention.id" style="position: relative; z-index: 2">
                <v-timeline-item v-if="$moment(mention.publication_date).year() === year" hide-dot>
                  <a v-if="mention.file[0]" :href="mention.file[0].url" target="_blank" rel="noreferrer">
                    {{ mention.title }}
                  </a>
                  <a v-else-if="mention.url" :href="mention.url" target="_blank" rel="noreferrer">
                    {{ mention.title }}
                  </a>
                  <span v-else>
                    {{ mention.title }}
                  </span>
                </v-timeline-item>
              </div>
            </div>
          </v-timeline>
        </v-col>
      </v-row>
    </section>
  </v-container>
</template>

<script>
import page from '~/plugins/mixins/page';

export default {
  mixins: [page],
  async asyncData({$axios, error, $moment}) {
    try {
      const {data} = await $axios.get('/mentions');

      return {
        mentions: data.data,
        publicationYears: [...new Set(data.data.map(mention => $moment(mention.publication_date).year()))].sort().reverse(),
      };
    } catch (e) {
      error({statusCode: 503, message: e.message});
    }
  },
};
</script>

<style lang="sass" scoped>
.year
  margin-top: -50px

.leaf
  position: relative
  height: 100px
  left: -35px
  top: 70px
  background: url('~assets/img/icon-leaf.svg') no-repeat

  &-input
    position: absolute
    top: 24px
    left: 14px
</style>
